export const defaultTransition = {
    ease: [0.65, 0, 0.35, 1],
    duration: 0.25,
};

export const easeInOut = {
    ease: "easeInOut",
    duration: 0.5,
};

